import { Box, Tag, Td, Text, Tr } from '@chakra-ui/react';
import { statusFormatter } from '@diamond/shared/utils';
import get from 'lodash.get';
import { Fragment } from 'react';

import { TableColumns } from './ListTable';

interface TableRowProps<T> {
  data: T[];
  columns: TableColumns<T>[];
}

interface TableRowCellProps<T> {
  item: T;
  column: TableColumns<T>;
}

const capitalizeFirstLetter = (text: string) => {
  const rawData = text.split(' ');
  const formattedData = rawData
    .map((value) => (value ? value[0].toUpperCase() + value.slice(1) : ''))
    .join(' ');
  return formattedData;
};

function TableRowCell<T>({ item, column }: TableRowCellProps<T>): JSX.Element {
  const value = get(item, column.key);
  return <Td>{column.render ? column.render(column, item) : value}</Td>;
}

export function TableRow<T>({ data, columns }: TableRowProps<T>): JSX.Element {
  return (
    <>
      {data.map((item, itemIndex) => {
        const divider = get(item, 'divider');
        const subPONumber = get(item, 'sub_po_number');
        const status = get(item, 'status');
        return (
          <Fragment key={itemIndex}>
            {divider && (
              <Tr>
                <Td colSpan={columns.length}>
                  <Box color="white" bg="blue" rounded="md" px="2" py="2">
                    <Text>
                      {`${capitalizeFirstLetter(divider as string)} ${
                        subPONumber ? `- ${subPONumber}` : ''
                      }`}{' '}
                      {status !== 'draft' ? (
                        <Tag borderRadius="full" ml="2" color="blue">
                          {(() => {
                            if (status === 'cancelled')
                              return 'Dibatalkan: Stok habis';
                            return statusFormatter(status as string);
                          })()}
                        </Tag>
                      ) : null}
                    </Text>
                  </Box>
                </Td>
              </Tr>
            )}
            <Tr key={itemIndex}>
              {columns.map((column, columnIndex) => (
                <TableRowCell
                  key={`table-row-cell-${columnIndex}`}
                  item={item}
                  column={column}
                />
              ))}
            </Tr>
          </Fragment>
        );
      })}
    </>
  );
}
